module.exports = __webpack_public_path__ + "img/arrow-right-from-line.6e101f16.svg";